import { ModulePackFE_EHRInstance, ModulePackFE_EHROrderConfiguration, ModulePackFE_Facility, ModulePackFE_InstallationFlowsheetConfiguration, ModulePackFE_OrganizationModule, ModulePackFE_UserDB } from './_entity.js';
import { ModulePackFE_EHRInstanceKBVersionDB } from './_entity/instance/ehr-instance-kb-version/module-pack.js';
import { ModulePackFE_ArtifactDB } from './_entity/artifact/index.js';
import { ModulePackFE_EHRFlowsheetConfiguration } from './_entity/instance/ehr-flowsheet-configuration/index.js';
import { ModulePackFE_EHRInstallation } from './_entity/installation/ehr-installation/index.js';
import { ModulePackFE_OrderConfiguration } from './_entity/installation/order-configuration/module-pack.js';
import { ModulePackFE_Environment } from './_entity/installation/environment/index.js';
import { ModulePackFE_AdvisorConfiguration } from './_entity/instance/advisor-configuration/index.js';
import { ModulePackFE_LaunchUrls } from './_entity/launch-urls/index.js';
export const ModulePackFE_Organization = [
    ...ModulePackFE_OrganizationModule,
    ...ModulePackFE_EHROrderConfiguration,
    ...ModulePackFE_EHRInstance,
    ...ModulePackFE_EHRInstallation,
    ...ModulePackFE_OrderConfiguration,
    ...ModulePackFE_EHRFlowsheetConfiguration,
    ...ModulePackFE_Facility,
    ...ModulePackFE_EHRInstanceKBVersionDB,
    ...ModulePackFE_ArtifactDB,
    ...ModulePackFE_UserDB,
    ...ModulePackFE_Environment,
    ...ModulePackFE_AdvisorConfiguration,
    ...ModulePackFE_LaunchUrls,
    ...ModulePackFE_InstallationFlowsheetConfiguration
];
//# sourceMappingURL=module-pack.js.map